"use client";
import { FC } from "react";
import { Text, TextBig, TextMedium } from "./components/Text";
import EmailBlockPrivacy from "./components/EmailBlock";
import Table1 from "./components/Table1";
import Table2 from "./components/Table2";
import { BlocksRenderer } from "@strapi/blocks-react-renderer";

type Props = {
	data: any;
	tableData: any;
};

const PrivacyPolicyScreen: FC<Props> = ({ data, tableData }) => {
	const prettyData = (data?.data ?? []).map((el: any) => el.attributes);
	const prettyTableData = (tableData?.data ?? [])
		.sort((a: any, b: any) => a.id - b.id)
		.map((el: any) => el.attributes);

	const placeForTable = /\/table_\d+\//g;
	const placeForEmailBlock = /\/email_block\//;
	const normalizeMargin = /\/normalize_margin\//;
	const regexDate = /^\/date_/;

	const findNumber = (str: any) => {
		const regex = /\/table_(\d+)\//;
		const match = str.match(regex);

		if (match) {
			const number = parseInt(match[1]);
			return number;
		} else {
			console.log("Number is undefined");
		}
	};

	return (
		<div className='bg-main pt-[98px] pb-[20px] px-[80px] max-desktop:pt-[39px]  max-desktop:px-[33px] max-tablet:px-[16px]'>
			<div className='flex flex-col w-fit mr-auto'>
				<p className='text-[72px] leading-[80px]  max-desktop:text-[40px] tracking-[4px] max-tablet:tracking-[1px] font-bold  max-desktop:leading-[42px]'>
					PRIVACY POLICY WBTBRIDGE.COM
				</p>
			</div>
			{prettyData.length === 0 && (
				<p className='text-[23px] max-desktop:text-[16px] text-white opacity-85 mt-[24px]'>
					Content unavailable.
				</p>
			)}
			{prettyData.map((el: any, index: number) => (
				<BlocksRenderer
					key={index}
					content={el.text}
					modifiers={{
						bold: ({ children }) => (
							<span className='font-[600]'>{children}</span>
						),
					}}
					blocks={{
						paragraph: ({ children }) => {
							//@ts-ignore
							if (children[0].props.text.match(regexDate)) {
								return (
									<p className='text-[35px] mt-[26px] font-[400] max-desktop:text-[20px] max-desktop:mt-[16px] '>
										{/*@ts-ignore */}
										{children[0].props.text.replace(regexDate, "")}
									</p>
								);
							}
							//@ts-ignore
							if (children[0].props.text.match(placeForEmailBlock)) {
								return <EmailBlockPrivacy />;
							}
							//@ts-ignore
							if (children[0].props.text.match(normalizeMargin)) {
								return <div className='mt-[-65px] max-desktop:mt-[-45px]' />;
							}
							//@ts-ignore
							if (children[0].props.text.match(placeForTable)) {
								// @ts-ignore
								const tableIndex = findNumber(children[0].props.text);
								const tableEntry =
									typeof tableIndex === "number"
										? prettyTableData[tableIndex]
										: undefined;
								if (!tableEntry) {
									return null;
								}
								if (tableIndex === 0) {
									return (
										<Table2
											data={
												//@ts-ignore
												tableEntry.texts
											}
											columnsNames={
												//@ts-ignore
												tableEntry.columnNames
											}
										/>
									);
								}
								return (
									<Table1
										data={
											//@ts-ignore
											tableEntry.texts
										}
										columnsNames={
											//@ts-ignore
											tableEntry.columnNames
										}
										// @ts-ignore
										bold={tableIndex === 3}
									/>
								);
							}
							return <Text>{children}</Text>;
						},
						heading: ({ children, level }) => {
							switch (level) {
								case 3:
									return <TextBig>{children}</TextBig>;
								case 4:
									return <TextMedium>{children}</TextMedium>;
								case 6:
									return (
										<p className='text-[23px]  font-[500] max-desktop:text-[16px] mt-[-42px] text-[rgba(255,255,255,0.84)] max-desktop:mt-[-22px]  leading-[28px] tracking-[1px]'>
											{children}
										</p>
									);
								default:
									return <Text>{children}</Text>;
							}
						},

						list: ({ children }) => (
							<ul className='list-disc text-[35px] max-desktop:text-[20px] max-desktop:leading-[23px] leading-[34px] font-[300] pl-[35px] py-[40px] max-desktop:py-[26px]'>
								{/*@ts-ignore */}
								{children.map((el, index) => el)}
							</ul>
						),
					}}
				/>
			))}
		</div>
	);
};

export default PrivacyPolicyScreen;

//		<div className='mt-[-65px] max-desktop:mt-[-45px]'></div>
